import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';
import { enablePush, disablePush } from '../lib/push';
import type { NotificationPreferences } from '@chore-project/shared';

export function useNotificationPreferences() {
  return useQuery<NotificationPreferences>({
    queryKey: ['notification-preferences'],
    queryFn: async () => {
      const { data } = await apiClient.get<NotificationPreferences>('/me/notification-preferences');
      return data;
    },
  });
}

/**
 * Toggle push notifications. Enabling requests the native permission + registers
 * the device; disabling clears consent and removes the device. Resolves to the
 * resulting enabled state (false if the user denied the OS permission).
 */
export function useTogglePush() {
  const queryClient = useQueryClient();
  return useMutation<boolean, Error, boolean>({
    mutationFn: async (enable) => {
      if (enable) return enablePush();
      await disablePush();
      return false;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
    },
  });
}
